import { Divider, IconButton } from "@mui/material";
import { UserInfoContainer, UserName, UserSettingsIcon } from "./userInfo.styles";
import { models } from "types/api/viewModels.ts";

interface UserInfoProps {
	user?: models["UserViewModel"];
	handleClickNavigationOption: () => void;
}

const UserInfo = ({ user, handleClickNavigationOption }: UserInfoProps) => {
	const openSettings = async () => {
		handleClickNavigationOption();
	};

	return (
		<UserInfoContainer data-testid="user-info">
			<Divider data-testid="user-info-divider-top" />
			<div>
				{user?.firstName !== undefined && (
					<UserName data-testid="user-info-user-designer-name">{`${user?.firstName} ${user?.lastName}`}</UserName>
				)}
				<IconButton
					onClick={openSettings}
					data-id="user-settings-button"
				>
					<UserSettingsIcon data-testid="user-settings" />
				</IconButton>
			</div>
			<Divider data-testid="user-info-divider-bottom" />
		</UserInfoContainer>
	);
};

export default UserInfo;
